// Modules
import { format } from 'date-fns';
import React from 'react';
import { Row } from 'react-table';

// Components
import NoActivity from '../../components/Column/NoActivity';

// Util
import { activityCellInfo, classList } from '../../util/util';

// Config
import { CLASS_PREFIX, TIME_FORMAT } from '../../config';
import { IBasstrakkCatch, IDataProps } from '../../types';

interface ICatchCellProps {
  lastCatch: IBasstrakkCatch;
  row: Row<IDataProps>;
}

const ActivityCatchCell = (props: ICatchCellProps) => {
  const { lastCatch, row } = props;
  const { FishWeightPdsOz: weight } = lastCatch;
  const { catchText, catchClass } = activityCellInfo(row.original.PollsLeft);

  if (!lastCatch) {
    return <NoActivity classPrefix={CLASS_PREFIX} />;
  }
  // Normalize the date
  const catchTime = new Date(lastCatch.Time).getTime();

  return (
    <>
      <div
        className={classList(
          `${CLASS_PREFIX}catch-activity ${CLASS_PREFIX}cell__activity_catch`
        )}
      >
        {catchText}{' '}
      </div>
      <div
        className={classList(
          `${CLASS_PREFIX}catch-activity ${CLASS_PREFIX}cell__activity_weight`,
          catchClass
        )}
      >
        {weight}
      </div>
      <div
        className={classList(
          `${CLASS_PREFIX}catch-activity ${CLASS_PREFIX}cell__activity_time`
        )}
      >
        {' '}
        {format(catchTime, TIME_FORMAT)}
      </div>
    </>
  );
};

export default ActivityCatchCell;
